module.exports = __webpack_public_path__ + "media/images/emlurb_logo2-163cefd3.png";